// Convert category title to link
export const LinkConverter = (inputString) => {
  const normalizedString = inputString
    .toLowerCase()
    .normalize("NFD") // Normalize characters
    .replace(/[\u0300-\u036f()]/g, "") // Removing diacritics and parentheses
    .replace(/\s+/g, "-") // Replacing spaces with hyphens

  return normalizedString
}

// Get selected category object
export const findObjectByTitle = (inputString, data) => {
  const normalizedString = LinkConverter(inputString)
  return (
    data.find((obj) => LinkConverter(obj.title) === normalizedString) || null
  )
}

// Get URL
export const getLastSegment = (str) => {
  const segments = str.split("/")
  return segments[segments.length - 1]
}
